import React, { createElement } from 'react'
import { toast } from 'react-toastify'

export const toastSyncSuccess = (message: string) => {
  toast.success(
    createElement(
      'div',
      null,
      createElement('span', null, message),
      createElement(
        'p',
        { style: { margin: '6px 0 0', fontSize: 12, opacity: 0.85 } },
        'Sincronize o app para aplicar as alterações.'
      )
    ),
    { autoClose: 6000 }
  )
}
